export const ENTITY_TO_STEP_ROUTE: Readonly<Record<string, string>> = {
  // Step 1 — Legal Entity
  LegalEntityProfile: 'legal-entity',
  GuarantorLegalEntityProfile: 'legal-entity',

  // Step 2 — Individual KYC
  KYC: 'individual-kyc',
  IndividualKyc: 'individual-kyc',
  KYCPersonalInformation: 'individual-kyc',
  KycPersonalInformation: 'individual-kyc',
  KYCEmploymentAndWealth: 'individual-kyc',
  KycEmploymentAndWealth: 'individual-kyc',
  KYCGeneralInformation: 'individual-kyc',
  KycGeneralInformation: 'individual-kyc',
  GuarantorKYCPersonalInformation: 'individual-kyc',
  GuarantorKYCEmploymentAndWealth: 'individual-kyc',
  GuarantorKYCGeneralInformation: 'individual-kyc',
  GuarantorKycPersonalInformation: 'individual-kyc',
  GuarantorKycEmploymentAndWealth: 'individual-kyc',
  GuarantorKycGeneralInformation: 'individual-kyc',

  // Step 3 — Contact & Address
  LegalEntityContact: 'contact-address',
  GuarantorLegalEntityContact: 'contact-address',

  // Step 4 — Corporate Structure & Ownership
  ControllingPersonAssociation: 'corporate-structure-ownership',
  CorporateStructureOwnership: 'corporate-structure-ownership',
  ShareholderAssociation: 'corporate-structure-ownership',
  ShareholderLegalEntity: 'corporate-structure-ownership',
  GuarantorCorporateStructureOwnership: 'corporate-structure-ownership',
  GuarantorShareholderLegalEntity: 'corporate-structure-ownership',

  // Step 5 — Controlling Persons
  // ControllingPersonAssociation: 'controlling-persons',
  GuarantorControllingPersonAssociation: 'controlling-persons',

  // Step 6 — Directors & Executives
  DirectorExecutiveAssociation: 'directors-executives',
  GuarantorDirectorExecutiveAssociation: 'directors-executives',

  // Step 7 — Authorized Persons
  AuthorizedPersonAssociation: 'authorized-persons',
  GuarantorAuthorizedPersonAssociation: 'authorized-persons',

  // Step 8 — PEP Declarations
  PepDeclaration: 'pep-declarations',
  GuarantorPepDeclaration: 'pep-declarations',

  // Step 9 — Bank Details (API / hub entity name)
  LegalEntityBank: 'bank-custodian',
  /** @deprecated Legacy alias — keep until all environments emit LegalEntityBank */
  LegalEntityBankCustodian: 'bank-custodian',

  // Step 10 — Documents
  ApplicationDocument: 'documents',
  EntityDocument: 'documents',
  PersonDocument: 'documents',
  SkipDocument: 'documents',
  DeleteDocument: 'documents',
  UploadDocument: 'documents',
  GuarantorApplicationDocument: 'documents',

  // Step 11 — Guarantors (disabled — route commented out in onboarding-routing-module)
  // Guarantor: 'guarantors',

  // Step 12 — Signing Documents
  SigningDocuments: 'signing-documents',
};

/**
 * Maps validator `issues[].entity` values to review-submit section keys (step labels + navigation).
 * Used when the API nests multiple entities under one category (e.g. LegalEntityBank under LegalEntity).
 */
export const ENTITY_TO_VALIDATION_CATEGORY: Readonly<Record<string, string>> = {
  LegalEntityProfile: 'LegalEntity',
  LegalEntityBank: 'LegalEntityBank',
  LegalEntityBankCustodian: 'LegalEntityBank',
  LegalEntityContact: 'ContactAndAddress',
  ControllingPersonAssociation: 'ControllingPersons',
  DirectorExecutiveAssociation: 'DirectorsExecutives',
  AuthorizedPersonAssociation: 'AuthorizedPersons',
  PepDeclaration: 'PepDeclarations',
  KYCPersonalInformation: 'Kyc',
  KYCEmploymentAndWealth: 'Kyc',
  KYCGeneralInformation: 'Kyc',
  KycPersonalInformation: 'Kyc',
  KycEmploymentAndWealth: 'Kyc',
  KycGeneralInformation: 'Kyc',
  ApplicationDocument: 'Documents',
  // GuarantorApplication: 'Guarantors',
  ShareholderAssociation: 'Shareholders',
  ShareholderLegalEntity: 'Shareholders',
};

export function resolveValidationIssueCategory(
  parentCategoryKey: string,
  entityName?: string | null
): string {
  const entity = (entityName ?? '').trim();
  if (entity && ENTITY_TO_VALIDATION_CATEGORY[entity]) {
    return ENTITY_TO_VALIDATION_CATEGORY[entity];
  }
  return parentCategoryKey;
}

export function resolveStepRoute(entityName: string): string | null {
  return ENTITY_TO_STEP_ROUTE[entityName] ?? null;
}
